import React, { PureComponent } from 'react';
import { Query } from 'react-apollo'
import gql from 'graphql-tag'
//This component gets documents from the main page. Documents are not unique to the language version
export default (getSearch, key = 'documentResults') => WrappedComponent => class WithLangSearch extends PureComponent {
    render() {
        const search = getSearch(this.props)
        return (
            <Query
                variables={search}
                query={gql`
          query SearchDoc($search: String) {
            documents: documents(
                first: 100
                where: {
                  search: $search
                }
                ) {
                nodes {
                  id
                  title
                  link
                  date
                  status
                  file {
                    sourceUrl
                  }
                }
              }
              documentsTags: documents(
                first: 100
                where: {
                  tagSlugIn: [$search]
                }
                ) {
                nodes {
                  id
                  title
                  link
                  date
                  status
                  file {
                    sourceUrl
                  }
                }
              }
          }
        `}
            >
                {({ loading, error, data, refetch }) => (
                    <div>
                        {!error &&
                                <WrappedComponent
                                    {...this.props}
                                    {...{
                                        [`${key}Loading`]: loading,
                                        [key]: !loading ? data : undefined
                                    }}
                                />
                        }
                        {error && <h1>Error: {error.message}</h1>}
                    </div>
                )}
            </Query>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/withLangDoc.js